// 生成n位随机数并且前面补0
export function random(n: number) {
  return Math.floor(Math.random() * Math.pow(10, n))
    .toString()
    .padStart(n, '0')
}
